import {
    Done,
    Error,
    FileDownloadOff,
    Pending,
    PriorityHigh,
    QuestionMark,
    SdCardAlert,
    SmsFailed,
    TimerOff
} from "@mui/icons-material"
import { formatDateTime } from "./helpers"

export function getStatusLabelForMessage(message) {
    switch (message.status) {
        case 'pending':
            return {label: 'Pendente', icon: <Pending color="warning" sx={{marginRight: 1}}/>}
        case 'success':
            return {label: 'Sucesso', icon: <Done color="success" sx={{marginRight: 1}}/>}
        case 'ack_failed':
            return {label: 'Falha de acknowledgement', icon: <SmsFailed color="error" sx={{marginRight: 1}}/>}
        case 'import_error':
            return {label: 'Erro de importação', icon: <Error color="error" sx={{marginRight: 1}}/>}
        case 'import_invalid':
            return {label: 'Importação inválida', icon: <SdCardAlert color="error" sx={{marginRight: 1}}/>}
        case 'export_error':
            return {label: 'Erro de exportação', icon: <FileDownloadOff color="error" sx={{marginRight: 1}}/>}
        case 'export_invalid':
            return {label: 'Exportação inválida', icon: <PriorityHigh color="error" sx={{marginRight: 1}}/>}
        case 'obsolete':
            return {label: 'Obsoleto', icon: <TimerOff color="warning" sx={{marginRight: 1}}/>}
        default:
            return {
                label: 'Status desconhecido', icon: <QuestionMark color="info" sx={{marginRight: 1}}/>
            }
    }
}

export function canRedo(message) {
    return message.status !== 'success' && message.status !== 'pending' && message.status !== 'obsolete'
}

export const translateMessageKey = (key) => {
    switch (key) {
      case "id":
        return "ID";
      case "application_id":
        return "ID da Aplicação";
      case "queue_id":
        return "ID da Fila";
      case "message_id":
        return "ID da Mensagem";
      case "kind":
        return "Tipo";
      case "topic":
        return "Tópico";
      case "status":
        return "Status";
      case "entity_name":
        return "Nome da Entidade";
      case "entity_id":
        return "ID da Entidade";
      case "process_start_at":
        return "Início do Processamento";
      case "process_end_at":
        return "Fim do Processamento";
      case "receipt_id":
        return "ID do Recebimento";
      case "io_credential_id":
        return "ID da Credencial do Io";
      case "acknowledgement_id":
        return "ID da Confirmação";
      case "created_at":
        return "Criado em";
      case "updated_at":
        return "Atualizado em";
      case "feedback_message_id":
        return "ID da Mensagem de Retorno";
      case "message_updated_at":
        return "Mensagem Atualizada em";
      case "visibility_timeout":
        return "Tempo Limite de Visibilidade";
      case "producer_application_id":
        return "ID da Aplicação Produtora";
      default:
        return key;
    }
  };

  export const filterDisplayedKeys = (keys) => {
    const hiddenKeys = ["body", "acknowledgement", "message_payload"];
    return keys.filter((key) => !hiddenKeys.includes(key));
  };

  export const handleTimeKey = (message, key) => {
    const timeKeys = [
      "created_at",
      "updated_at",
      "process_start_at",
      "process_end_at",
    ];
    return timeKeys.includes(key)
      ? JSON.stringify(formatDateTime(message[key]))
      : JSON.stringify(message[key]);
  };